import axios from 'axios'
import { ApiResponse } from '../models/Base'
import { TableDto } from '../models/dto/SelfAssessment'
import { KPIGradeFilterDto } from '../models/dto/KPISummary'

const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/reports`

export function GetKPISummary(payload: KPIGradeFilterDto) {
    return axios.post<ApiResponse<TableDto>>(`${ACTION_API_URL}/kpi-summarise`, payload)
}


export function Export(payload: KPIGradeFilterDto) {
    return axios.post(`${ACTION_API_URL}/kpi-summarise/export`, payload)
}
